var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"comp-help"},[_c('div',{staticClass:"comp-help__icon"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"comp-help-arrow"}),_c('div',{class:[
        { 'comp-help__box-message--left': _vm.boxAlign === 'left' },
        { 'comp-help__box-message--right': _vm.boxAlign === 'right' },
        'comp-help__box-message' ],style:(("width:" + _vm.width + "px"))},[_c('span',{staticClass:"comp-help__message"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }